import type { EnemyDef, EnemyDropDef } from '../../content/enemies/enemies';
import type { PlayerState } from '../game/types';
import { addItem } from '../inventory/inventory';

export interface GrantedDrop {
  itemId: string;
  quantity: number;
}

export interface EnemyDropResult {
  player: PlayerState;
  drops: GrantedDrop[];
}

export function effectiveDropChance(baseChance: number, luck: number): number {
  return Math.min(0.95, Math.max(0, baseChance + Math.max(0, luck) * 0.01));
}

function rollQuantity(drop: EnemyDropDef, rng: () => number): number {
  const min = drop.minQuantity;
  const max = drop.maxQuantity;
  return min + Math.floor(rng() * (max - min + 1));
}

/** Luck improves each independent drop roll; inventory has no capacity limit. */
export function grantEnemyDrops(
  player: PlayerState,
  enemy: Pick<EnemyDef, 'drops'>,
  rng: () => number = Math.random,
): EnemyDropResult {
  let inventory = player.inventory;
  const drops: GrantedDrop[] = [];

  for (const drop of enemy.drops) {
    if (rng() >= effectiveDropChance(drop.chance, player.stats.luck)) {
      continue;
    }
    const quantity = rollQuantity(drop, rng);
    inventory = addItem(inventory, drop.itemId, quantity);
    drops.push({ itemId: drop.itemId, quantity });
  }

  return { player: { ...player, inventory }, drops };
}
